import { baseUrl } from 'wix-location';

const WIX_STATIC = 'https://static.wixstatic.com';

/**
 * @typedef {{
 *  width: number;
 *  dark: string;
 *  light: string;
 *  value: string;
 * }} Options
 * 
 * @param {'png' | 'svg' | 'jpeg'} type
 * @param {Options} options
 * @returns {string}
 */
export const buildURL = (type, { width, dark, light, value }) => [
        baseUrl,
        '_functions',
        type,
        width,
        dark,
        light,
        btoa(encodeURIComponent(value.trim())),
    ]
    .join('/');

/**
 * @param {string} val
 * @returns {boolean}
 */
export const hasContent = (val) => val.trim() !== '';

/**
 * @typedef {{
 * 	name: string;
 *	organisation: string;
 *	email: string;
 *	phone: string;
 *	phoneMobile: string;
 *	street: string;
 *	city: string;
 *	zipcode: string;
 *	country: string;
 *	url: string;
 * }} VCardInputData
 * 
 * @param {VCardInputData} inputData
 * @returns {string}
 */
export const buildVCard = (inputData) => {
    const vCardQRValue = `
BEGIN:VCARD
VERSION:3.0
${inputData.name ? 'N:' + inputData.name : 'null'}
${inputData.organisation ? 'ORG:' + inputData.organisation : 'null'}
${inputData.email ? 'EMAIL:' + inputData.email : 'null'}
${inputData.phone ? 'TEL;TYPE=Home:' + inputData.phone : 'null'}
${inputData.phoneMobile ? 'TEL;TYPE=Mobile:' + inputData.phoneMobile : 'null'}
${inputData.street || inputData.city || inputData.country ? 'ADR;TYPE=Home:;;' + inputData.street + ';' + inputData.city + ';' + inputData.zipcode + ';' + inputData.country : 'null'}
${inputData.url ? 'URL:' + inputData.url : 'null'}
END:VCARD`;
    return vCardQRValue.replace(/null\n/gm, "");
}

export function getStaticUrl(image) {
    const { name, dir, w, h } = parseURL(image);

    return `${WIX_STATIC}/${dir}/${name}`;
    // return `${WIX_STATIC}/${name}/v1/fit/w_${w},h_${h}`;
}

function parseURL(url) {
    const [protocol] = url.split('/', 1);

    if (protocol === 'image:') {
        const [, , , name, size] = url.split('/');
        const [w, h] = size.split('_');

        return { name, w, h, dir: 'media' };
    }

    if (protocol === 'wix:image:') {
        const [, , , name] = url.split('/');
        const [, query] = url.split('#');
        const w = query.replace(/(?:[\s\S]*)(?:originWidth=)([0-9]+)(?:[\s\S]*)$/, '$1');
        const h = query.replace(/(?:[\s\S]*)(?:originHeight=)([0-9]+)(?:[\s\S]*)$/, '$1');

        return { name, w, h, dir: 'media' };
    }

    if (protocol === 'wix:document:') {
        const [, , , name] = url.split('/');

        return { name, dir: 'ugd' };
    }
}